module.exports = __webpack_public_path__ + "img/Liquid-Cheese.391c78cb.svg";